import { useTranslation } from 'next-i18next';
import { FC, MouseEventHandler, ReactNode, useCallback, useMemo } from 'react';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import TopBarHeaderItem from '@bridebook/web/components/app/top-bar/top-bar-header-item';
import { navigateToVenuesAndSuppliers } from '@bridebook/web/lib/search-landing/actions';
import { useDispatch, useSelector } from '@bridebook/web/lib/utils';
import { getVenueBooked } from '@bridebook/web/lib/weddings/selectors';

interface NavigateToSearchButtonProps {}

export const NavigateToSearchButton: FC<NavigateToSearchButtonProps> = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const market = useMarket();
  const hasFullDirectory = market.hasFullDirectory;
  const isVenueBooked = useSelector(getVenueBooked);

  const searchToggle: MouseEventHandler<Element | ReactNode> = useCallback(
    (e) => {
      e.preventDefault();
      dispatch(navigateToVenuesAndSuppliers());
    },
    [dispatch],
  );

  const searchButtonText = useMemo(() => {
    if (hasFullDirectory) {
      return isVenueBooked ? t('common:menu.searchSuppliers') : t('common:menu.searchVenues');
    } else {
      return t('common:menu.searchVenues');
    }
  }, [hasFullDirectory, isVenueBooked, t]);

  return (
    <TopBarHeaderItem
      onClick={searchToggle}
      label={searchButtonText}
      icon="search"
      dataName="topbar-search-toggle-button"
    />
  );
};
